// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__12X7l","tab":"Tabs_tab__2umNg","tabActive":"Tabs_tabActive__Z6AgV"};